import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BalloonIcon from 'assets/icons/balloon-icon.png'
import ShareIcon from 'assets/icons/share-icon.png'
import moment from 'moment'
import styles from './sign-up-detail-card.scss'

class SignUpDetailCard extends Component {
  state = {
    showToast: false
  }

  handleShare = () => {
    navigator.clipboard.writeText(window.location.href)
    this.setState({ showToast: true }, () => {
      setTimeout(() => {
        this.setState({ showToast: false })
      }, 2000)
    })
  }

  render() {
    const { signUpDetail, type } = this.props

    return (
      <div className={styles['sign-up-info-wrapper']}>
        <img className={styles['sign-up-info-image']} src={signUpDetail.image} />
        <div className={styles['sign-up-info']}>
          <div className={styles['sign-up-info-header']}>
            <div className={styles['sign-up-info-avatar']}>
              <img src={signUpDetail.avatar} alt="" />
            </div>
            {type === 'detail' && (
              <div className={styles['sign-up-info-share']} onClick={this.handleShare}>
                <img src={ShareIcon} width="12" />
                <span>share</span>
              </div>
            )}
          </div>

          <span className={styles['sign-up-info-name']}>{signUpDetail.name}</span>

          {signUpDetail.eventName && (
            <div className={styles['sign-up-info-event']}>
              <img src={BalloonIcon} width={18} />
              <span>{signUpDetail.eventName}</span>
            </div>
          )}

          {signUpDetail.ends_at && (
            <div className={styles['sign-up-info-endDate']}>
              <label>End Date: </label>
              <span>{moment(signUpDetail.ends_at).format('ddd,MMM DD,YYYY,h:mm A')}</span>
            </div>
          )}

          <div className={styles['sign-up-info-line']} />

          <div>
            <div className={styles['sign-up-info-host']}>
              <label>Host: </label>
              <span>{signUpDetail.createName}</span>
            </div>
            <div className={styles['sign-up-info-createDate']}>
              <label>Created: </label>
              <span>{moment(signUpDetail.created_at).format('MMM DD')}</span>
            </div>
          </div>

          <div className={styles['sign-up-info-notes']}>
            <label>Notes: </label>
            <p>{signUpDetail.notes}</p>
          </div>
        </div>
        <div className={styles['sign-up-info-mobile']}>
          <span className={styles['sign-up-info-name']}>{signUpDetail.name}</span>

          {signUpDetail.eventName && (
            <div className={styles['sign-up-info-event']}>
              <img src={BalloonIcon} width={18} />
              <span>{signUpDetail.eventName}</span>
            </div>
          )}

          {signUpDetail.ends_at && (
            <div className={styles['sign-up-info-endDate']}>
              <label>End Date: </label>
              <span>{moment(signUpDetail.ends_at).format('ddd,MMM DD,YYYY,h:mm A')}</span>
            </div>
          )}

          <div className={styles['sign-up-info-creator']}>
            <div className={styles['sign-up-info-avatar']}>
              <img src={signUpDetail.avatar} width="25px" alt="" />
            </div>
            <div className={styles['sign-up-info-creator-name']}>{signUpDetail.createName}</div>
            <div className={styles['sign-up-info-createDate']}>
              <label>Created: </label>
              <span>{moment(signUpDetail.created_at).format('MMM DD')}</span>
            </div>
          </div>

          <div className={styles['sign-up-info-notes']}>{signUpDetail.notes}</div>
        </div>

        {this.state.showToast && (
          <div className={styles['toast-container']}>
            <p className={styles['title']}>Link Copied!</p>
            <p className={styles['note']}>Paste and share via text, email, or social media</p>
          </div>
        )}
      </div>
    )
  }
}

SignUpDetailCard.defaultProps = {
  type: 'detail'
}

SignUpDetailCard.propTypes = {
  signUpDetail: PropTypes.object,
  type: PropTypes.string
}

export default SignUpDetailCard



// WEBPACK FOOTER //
// ./src/containers/time-poll/TimePollContainer/SignUp/CreateSignUp/SignUpDetailCard/SignUpDetailCard.jsx